var path = 'areas/projects/views/package_list.html';
var html = "<ul class=packages> <li ng-repeat=\"pkg in packages\" ng-class=pkg.State> <h4><dfn title='{{ pkg.PackageId + \" from feed \" + pkg.FeedName }}'>{{ pkg.StepName }}: <span ng-show=\"pkg.StepName != pkg.PackageId\">{{ pkg.PackageId }}</span> version {{ pkg.Version }}</dfn></h4> <div ng-show=pkg.Notes ng-bind-html-unsafe=pkg.Notes></div> <div ng-show=pkg.ErrorNotes><div class=\"alert alert-warning\">{{pkg.ErrorNotes}}</div></div> </li> </ul> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/views/package_list.html
// module id = 939
// module chunks = 1